<script setup lang="ts">
  import { BottomSheet, Typo, TypoVariant } from '@travelata-libs/ui-kit';
  import { ref } from 'vue';
  import MobilePrimaryButton from '@/shared/ui/MobilePrimaryButton.vue';
  import { useMobileSearchFlowContext } from '../../../model/useMobileSearchFlow';
  import TouristsRoomsTemplate from '../TouristsRoomsTemplate.vue';

  const flow = useMobileSearchFlowContext();

  const bottomSheetRef = ref<null | { close: () => Promise<void> }>(null);

  const onNext = async (): Promise<void> => {
    await bottomSheetRef.value?.close();
  };
</script>

<template>
  <BottomSheet
    ref="bottomSheetRef"
    root-class="mobile-tourists-sheet"
    :animated="true"
    :icon-closable="true"
    @close="flow.closeTourists"
  >
    <template #header>
      <Typo
        class="mobile-tourists-sheet__typo"
        :variant="TypoVariant.Heading5"
        tag="span"
      >
        {{ flow.texts.labels.tourists }}
      </Typo>
    </template>

    <div
      class="mobile-tourists-sheet__body"
      data-testid="search-form-mobile-tourists"
    >
      <TouristsRoomsTemplate />
    </div>

    <template #footer>
      <MobilePrimaryButton
        testid="search-form-mobile-tourists-next"
        @click="onNext"
      >
        {{ flow.primaryTexts.next }}
      </MobilePrimaryButton>
    </template>
  </BottomSheet>
</template>

<style scoped lang="scss">
  .mobile-tourists-sheet {
    &__body {
      box-sizing: border-box;
      width: 100%;
    }

    &__typo {
      padding-top: var(--spacing-xxs);
      text-align: center;
      width: 100%;
    }
  }
</style>
